
const currencyFormat = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'CAD'
})

export const formatMoney = (amount) => currencyFormat.format(amount)